import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

import { HelperService } from 'app/services';
import { debounce } from 'lodash';

@Component({
  selector: 'app-single-filter',
  templateUrl: './app-single-filter.component.html',
  styleUrls: ['./app-single-filter.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppSingleFilterComponent implements OnInit {
  @Input() type: any = 'tag';
  @Input() data: any[] = [];
  @Input() scrollHeight: string = '180px';
  @Input() nameField: string = 'name';
  @Input() valueField: string = 'id';
  @Input() selectedValue: any = {};
  @Input() name: string = '';
  @Input() listData: any[] = [];
  @Input() isInActive: boolean = false;
  @Input() searchFilter: any = {
    isSearchEnable: false,
    searchPlaceholder: 'Search',
    serachField: 'name',
    maxLength: 1000,
  };

  @Output() appChangeFilter = new EventEmitter<any>();
  @Output() scroll = new EventEmitter<void>();
  query: any = '';

  constructor(private helperService: HelperService) {}

  ngOnInit() {}

  emitSelectedTags() {
    const [selectedValue] = this.data.filter((data) => data.isChecked);
    this.appChangeFilter.emit(selectedValue);
  }

  onOptionClick(data: any) {
    this.data.forEach((option) => {
      option.isChecked = option[this.valueField] === data[this.valueField];
    });
    this.query = '';
    this.onSearch(this.query, this.query);
    this.emitSelectedTags();
  }

  onSearch(e: any, searchFilter: string) {
    this.query = e.toLowerCase();
    if (!this.query) {
      this.listData = this.helperService.deepCopy(this.data);
    }
    this.listData = this.data.filter((data) => {
      if (data[searchFilter]) {
        return ('' + data[searchFilter]).toLowerCase().includes(this.query);
      } else {
        return data;
      }
    });
  }

  onScroll = debounce((event: any) => {
      // if (this.isLoading) return;
  
      if (event.target?.offsetHeight + event.target?.scrollTop >= event.target?.scrollHeight - 1) {
        this.scroll.emit();
      }
    }, 300);
}
